const defaults = {
    stiffness: 100.0,
    damping: 10.0,
    mass: 1.0,
};

export { defaults };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@motionone/generators/dist/spring/defaults.es.js
// module id = nJLS
// module chunks = 0